export const ICON_ORIENTATION = { left: 'left', right: 'right' };
